<!-- ── Mobile view ─────────────────────────────────────────── -->
@if (useMobileView) {
  <div>
    <div class="srch-mob-toolbar">
      <div class="srch-mob-toolbar-inner">
        <div class="srch-mob-title-wrap">
          <span class="srch-mob-title">Search Results</span>
          @if (searchCritera) {
            <span class="srch-mob-criteria">&ldquo;{{searchCritera}}&rdquo;</span>
          }
        </div>
        <button pButton type="button"
          class="p-button-sm p-button-outlined srch-mob-icon-btn"
          (click)="mobileToggleDisabled()"><span class="p-button-label">{{showDisabled ? 'Hide Disabled' : 'Show Disabled'}}</span></button>
        </div>
      </div>
      @if (!ListBookings || ListBookings.length === 0) {
        <div style="padding: 2rem; text-align:center; color:#64748b;">
          No bookings found.
        </div>
      }
      @if (ListBookings && ListBookings.length > 0) {
        <div class="surface-card shadow-2">
          <p-table [value]="ListBookings"
            sortField="startTime"
            [paginator]="true" [rows]="10"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            [rowsPerPageOptions]="[10,25,50]"
            [globalFilterFields]="['name','bookingId','bookingIdHR','packageName']"
            responsiveLayout="scroll"
            styleClass="mob-booking-table">
            <ng-template #header>
              <tr>
                <th class="mob-stripe-th"></th>
                <th pSortableColumn="startTime">Booking</th>
                <th pSortableColumn="total" style="text-align:right">Amount</th>
                <th style="width:48px"></th>
              </tr>
            </ng-template>
            <ng-template #body let-data>
              <tr [ngStyle]="{'background-color': data.disabled ? '#fff1f2' : '#ffffff'}"
                class="mob-data-row"
                (click)="editdatanew(data.bookingId)">
                <td class="mob-status-stripe"
                  [ngStyle]="{'background-color': data.disabled ? '#ef4444' : '#94a3b8'}">
                </td>
                <td class="mob-main-cell">
                  <div class="mob-main-line1">
                    <span class="mob-time">{{data.startTime | date:'dd/MM' : 'UTC'}}&nbsp;<span style="font-weight:400; color:#64748b;">{{data.startTime | date:'HH:mm' : 'UTC'}}</span></span>
                    <span class="mob-name">{{data.name}}</span>
                    <span class="mob-inline-icons">
                      @if (data.publicBooking) {
                        <i   class="pi pi-user              mob-iico"></i>
                      }
                      @if (data.awaitingpayment) {
                        <i class="pi pi-dollar            mob-iico mob-iico--red" pTooltip="Payment link sent"></i>
                      }
                      @if (data.notes) {
                        <i           class="pi pi-exclamation-circle mob-iico mob-iico--red" [pTooltip]="data.notes"></i>
                      }
                    </span>
                  </div>
                  <div class="mob-main-line2">
                    <span class="mob-bookingid">{{data.bookingIdHR}}</span>
                    @if (data.packageName) {
                      <span class="mob-pkg">&nbsp;&middot;&nbsp;{{data.packageName}}</span>
                    }
                    @if (data.guests) {
                      <span class="mob-guests">&nbsp;&middot;&nbsp;{{data.guests}} guest{{data.guests != 1 ? 's' : ''}}</span>
                    }
                  </div>
                </td>
                <td class="mob-money-cell">
                  <div class="mob-total">{{data.total | currency: (data.currency || CurrencySymbol)}}</div>
                  <div [class.mob-os--overdue]="data.outstanding > 0" [class.mob-os--paid]="data.outstanding <= 0">
                    {{data.outstanding | currency: (data.currency || CurrencySymbol)}}
                  </div>
                </td>
                <td class="mob-action-cell" (click)="$event.stopPropagation()">
                  <button pButton type="button"
                    class="p-button-text p-button-plain mob-action-btn"
                    (click)="selectedAction = data; srchRowActionPanel.toggle($event)" [iconOnly]="true"><span class="p-button-icon pi pi-ellipsis-v" aria-hidden="true"></span></button>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        }
        <p-popover #srchRowActionPanel appendTo="body">
          <ng-template pTemplate>
            <div class="mob-action-list">
              <button pButton type="button" class="p-button-outlined mob-action-item"
                (click)="editdatanew($safeNavigationMigration(selectedAction?.bookingId)); srchRowActionPanel.hide()"><span class="p-button-icon p-button-icon-left pi pi-pencil" aria-hidden="true"></span><span class="p-button-label">Edit Booking</span></button>
                <button pButton type="button" class="p-button-outlined p-button-danger mob-action-item"
                  (click)="disableData($safeNavigationMigration(selectedAction?.bookingId)); srchRowActionPanel.hide()"><span class="p-button-icon p-button-icon-left pi pi-calendar-times" aria-hidden="true"></span><span class="p-button-label">Disable Booking</span></button>
                </div>
              </ng-template>
            </p-popover>
          </div>
        }

        <!-- ── Desktop view ────────────────────────────────────────── -->
        @if (!useMobileView && ListBookings) {
          <div class="p-3 flex flex-column flex-auto">
            <h3 style="margin-bottom: -38px" i18n>Search Results</h3>
            <div class="list-toolbar" style="text-align: right; margin-bottom: 20px;">
              <p-togglebutton class="p-component" [(ngModel)]="showDisabled" onLabel="Show Disabled" offLabel="Hide Disabled" offIcon="pi pi-times" onIcon="pi pi-check" [style]="{'margin-right': '10px', 'color' : 'white', 'background-color': '#EF4444', 'font-weight': 'normal', 'height': '50px'}" (click)="toggleDisabled()">
              </p-togglebutton>
              <span class="p-input-icon-left ml-auto" style="margin-right:20px; ">
                <i class="pi pi-search"></i>
                <input pInputText type="text" placeholder="Filter Results" (input)="resourceTable.filterGlobal($event.target.value, 'contains')" style="height: 50px;padding-left:33px;" />
              </span>
            </div>
            <div class="surface-card p-4 shadow-2 border-round">
              <p-table  #resourceTable
                [first]=currentpage
                [value]="ListBookings" sortField="startTime" [paginator]="true" [rows]="10"
                [showCurrentPageReport]="true" responsiveLayout="scroll"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                [rowsPerPageOptions]="[10,25,50]"
                [globalFilterFields]="['name', 'bookingId', 'bookingIdHR', 'packageName']"
                [(selection)]="selectedItem"
                responsiveLayout="scroll"
                datakey="resourceID"
                (onPage)="onPageChange($event)"
                [selectionPageOnly]="true">
                <ng-template #header>
                  <tr>
                    <th width="1%">
                      &nbsp;
                    </th>
                    <th width="1%">
                      &nbsp;
                    </th>
                    <th width="1%">
                      &nbsp;
                    </th>
                    <th pSortableColumn="bookingId" width="12%">Sales ID
                      <p-sorticon [field]="bookingIdHR"></p-sorticon>
                    </th>
                    <th pSortableColumn="startTime" width="12%">Start Date
                      <p-sorticon [field]="startTime"></p-sorticon>
                    </th>
                    <th pSortableColumn="startTime" width="10%">Start
                      <p-sorticon [field]="startTime"></p-sorticon>
                    </th>
                    <th pSortableColumn="name" width="10%">Name
                      <p-sorticon [field]="name"></p-sorticon>
                    </th>
                    <th pSortableColumn="packageName" width="11%">Package
                      <p-sorticon [field]="packageName"></p-sorticon>
                    </th>
                    <th pSortableColumn="guests" width="10%">Guests
                      <p-sorticon [field]="guests"></p-sorticon>
                    </th>
                    <th pSortableColumn="total" width="8%">Total
                      <p-sorticon [field]="total"></p-sorticon>
                    </th>
                    <th pSortableColumn="outstanding" width="8%">O/S
                      <p-sorticon [field]="outstanding"></p-sorticon>
                    </th>
                    <th width="5%"></th>
                  </tr>
                </ng-template>
                <ng-template #body let-data>
                  <tr [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}" onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'" onmouseout="this.style.backgroundColor=this.originalstyle;" style="cursor:pointer" (click)="editdatanew(data.bookingId)">
                    <td>
                      @if (data.publicBooking) {
                        <span class="pi pi-user"></span>
                      }
                    </td>
                    <td>
                      @if (data.notes != '' && data.notes != null) {
                        <span style="color:red" class="pi pi-exclamation-circle" pTooltip="{{data.notes}}"></span>
                      }
                    </td>
                    <td>
                      @if (data.awaitingpayment) {
                        <span style="color:red" class="pi pi-dollar" pTooltip="A payment link has been sent for this booking."></span>
                      }
                    </td>
                    <td>{{data.bookingIdHR}}</td>
                    <td>{{data.startTime | date:'dd/MM/yy'}}</td>
                    <td>{{data.startTime | date:'HH:mm' : 'UTC'}}</td>
                    <td>{{data.name}}</td>
                    <td>{{data.packageName}}</td>
                    <td>{{data.guests}}</td>
                    <td>{{data.total | currency: (data.currency || CurrencySymbol)}}</td>
                    @if (data.outstanding <=0) {
                      <td>{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</td>
                    }
                    @if (data.outstanding >0) {
                      <td><span style="color: Red; font-weight: bold;">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</span></td>
                    }
                    <td (click)="$event.stopPropagation()"><button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" (click)="disableData(data.bookingId)" i18>
                      <span class="pi pi-calendar-times" style="margin-right:8px;"></span>
                      <span i18n>Disable</span>
                    </button></td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        }
